import Swiper, { Pagination, Manipulation } from "swiper";
import { initIntersectionObserver } from "@plugins";

const reviewsSliderMain = document.querySelector(".js-reviews-slider-main");

if (reviewsSliderMain) {
    initIntersectionObserver(reviewsSliderMain, initReviewsSliderMain);
}

function initReviewsSliderMain(slider) {
    const swiperContainer = slider.querySelector(".swiper");

    if (swiperContainer) {
        const swiper = new Swiper(swiperContainer, {
            modules: [Pagination, Manipulation],
            speed: 400,
            spaceBetween: 16,
            slidesPerView: 1.2,
            breakpoints: {
                567: {
                    slidesPerView: 2,
                    spaceBetween: 0,
                },
            },
            pagination: {
                el: ".js-reviews-slider-main-controls > .swiper-pagination",
                clickable: true,
                dynamicBullets: true,
                dynamicMainBullets: 3,
            },
            watchOverflow: true,
            navigation: {
                nextEl: ".js-reviews-slider-main-controls > .swiper-button-next",
                prevEl: ".js-reviews-slider-main-controls > .swiper-button-prev",
            },
        });

        if (window.mobileMedia) {
            const showAllLink = document.querySelector(".js-all-reviews-link");

            if (showAllLink) {
                showAllLink.classList.add("swiper-slide");
                swiper.appendSlide(showAllLink);
            }

            // swiper.once("reachEnd", () => {
            //     swiper.appendSlide(`
            //         <div class="swiper-slide reviews-slider-main__load-more js-load-more-reviews">
            //             <span>
            //                 Смотреть все <br>
            //                 отзывы
            //             </span>
            //         </div>
            //     `);

            //     const showAllSlide = swiperContainer.querySelector(".js-load-more-reviews");

            //     if (showAllSlide) {
            //         showAllSlide.addEventListener("click", () => {
            //             const link = document.querySelector(".js-all-reviews-link");

            //             if (!link) return;
            //             link.click();
            //         });
            //     }
            // });
        }
    }
}
